import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { OneClick } from '@/components/blocks/OneClick';
import { Box } from '@mui/material';
import { MouseEvent } from 'react';
import {
	actionsSX,
	primaryButtonSX,
	secondaryButtonSX,
} from '@/components/blocks/FreeShippingActivatedPopup/styles';

interface FreeShippingPopupActionsProps {
	onAddToCart: (event: MouseEvent<HTMLButtonElement>) => void;
	onClosePopup: () => void;
}

const ADD_BUTTON_LABEL = 'Agregar y pasar a pagar';
const CONTINUE_BUTTON_LABEL = 'Continuar sin agregar';

export const FreeShippingPopupActions = ({
	onAddToCart,
	onClosePopup,
}: FreeShippingPopupActionsProps) => (
	<Box sx={actionsSX}>
		<OneClick variant="contained" fullWidth sx={primaryButtonSX} onClick={onAddToCart}>
			{ADD_BUTTON_LABEL}
		</OneClick>
		<DpButton variant="unfocused" fullWidth sx={secondaryButtonSX} onClick={onClosePopup}>
			{CONTINUE_BUTTON_LABEL}
		</DpButton>
	</Box>
);
